__turbopack_context__.v({
  "bottom": "Ingredients-module-scss-module__d3EDVW__bottom",
  "down": "Ingredients-module-scss-module__d3EDVW__down",
  "fade-in": "Ingredients-module-scss-module__d3EDVW__fade-in",
  "fraction": "Ingredients-module-scss-module__d3EDVW__fraction",
  "heading": "Ingredients-module-scss-module__d3EDVW__heading",
  "info": "Ingredients-module-scss-module__d3EDVW__info",
  "infoText": "Ingredients-module-scss-module__d3EDVW__infoText",
  "ingredients": "Ingredients-module-scss-module__d3EDVW__ingredients",
  "link": "Ingredients-module-scss-module__d3EDVW__link",
  "list": "Ingredients-module-scss-module__d3EDVW__list",
  "listItem": "Ingredients-module-scss-module__d3EDVW__listItem",
  "nestedList": "Ingredients-module-scss-module__d3EDVW__nestedList",
  "paragraph": "Ingredients-module-scss-module__d3EDVW__paragraph",
  "printButton": "Ingredients-module-scss-module__d3EDVW__printButton",
  "root": "Ingredients-module-scss-module__d3EDVW__root",
  "share": "Ingredients-module-scss-module__d3EDVW__share",
  "shareLabel": "Ingredients-module-scss-module__d3EDVW__shareLabel",
  "title": "Ingredients-module-scss-module__d3EDVW__title",
  "up": "Ingredients-module-scss-module__d3EDVW__up",
});
